import ExternalPrenotazioniListPage from "./pages/ExternalPrenotazioniListPage.vue";
import ExternalePrenotazioniPresaInCaricoListPage from "./pages/ExternalePrenotazioniPresaInCaricoListPage.vue";
import TeamsystemIntegratorListPage from "./pages/TeamsystemIntegratorListPage.vue";

export default {
    ExternalPrenotazioniListPage,
    ExternalePrenotazioniPresaInCaricoListPage,
    TeamsystemIntegratorListPage
}